export class SendMailingListOperationsEntity {
    mailingList;
    recipients;

    constructor(mailingList, recipients) {
        this.mailingList = mailingList;
        this.recipients = recipients;
    }
}